"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _UiContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UiContext"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useFilterAPI = _ref => {
  let {
    api,
    lang,
    ...props
  } = _ref;
  const [filter, setFilter] = (0, _react.useState)({
    _loading: true
  });
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _location: {
      pathname: _pathname
    } = {}
  } = ui;
  const location = (0, _reactRouterDom.useLocation)();
  const {
    pathname
  } = location;
  const isCurrentLocation = pathname === _pathname;
  (0, _react.useEffect)(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchData = async () => {
      const params = [];
      params.push(`lang=${lang}`);
      for (const [key, value] of Object.entries(props)) {
        params.push(`${key}=${value}`);
      }
      const fetchURL = `${api}?${params.join("&")}`;
      try {
        const response = await _axios.default.get(fetchURL, {
          signal
        });
        if (response?.status === 200) {
          setFilter(response?.data);
          return;
        }
      } catch (error) {}
      setFilter({});
    };
    if (api && lang && !(0, _isEmpty.default)(props) && isCurrentLocation) {
      fetchData();
    }
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, isCurrentLocation, lang, JSON.stringify(props)]);
  return filter;
};
var _default = exports.default = useFilterAPI;